import React from "react";
import {Link} from "react-router-dom";
import PageLinks from "../../components/PageLinks/PageLinks";
import Img1 from "../../assets/images/leaders.webp";
import Img2 from "../../assets/images/leaders2.webp";
import Img3 from "../../assets/images/peers.webp";
import Img4 from "../../assets/images/govern.webp";
import "./membership.scss";

function Membership() {
    return (
        <>
            <div className="page-background">
                <div className=" mission-shadow header-wrapper">
                    <div className="col-md-12 membership-banner "></div>
                    <div className=" col-md-12 after">
                        <center>
                            <div
                                className="col-md-6 prefooter-writeup {
"
                            >
                                <h3>MEMBERSHIP</h3>
                                <p>Empowering change, one purpose-driven step at a time.</p>
                            </div>
                        </center>
                    </div>
                </div>
            </div>
            <PageLinks/>
            <center>
                <div className="col-md-6 mt4">
                    <h4>NEAD PROGRAMS FOR MEMBERS</h4>
                    <p>
                        NEAD offers enriching programs designed to empower members and advance its mission by blending
                        traditional knowledge with contemporary innovation. These initiatives support educational
                        improvement, provide essential resources, and facilitate professional growth through a strong,
                        collaborative community.
                    </p>
                </div>
            </center>
            <div className="col-md-8 offset-md-2 flexy mt5 membership-body">
                <div className="col-md-4 padd">
                    <center>
                        <div className="aizuI7  ">
                            {" "}
                            <svg
                                preserveAspectRatio="xMidYMid meet"
                                data-bbox="26 33.811 147.999 132.378"
                                viewBox="26 33.811 147.999 132.378"
                                height="200"
                                width="200"
                                xmlns="http://www.w3.org/2000/svg"
                                data-type="color"
                                role="presentation"
                                aria-hidden="true"
                                aria-label=""
                            >
                                <g>
                                    <path
                                        d="M167.833 166.189H32.167a3.08 3.08 0 0 1-3.083-3.079v-58.493c0-1.7 1.381-3.079 3.083-3.079a3.08 3.08 0 0 1 3.083 3.079v55.414h129.5v-55.414a3.08 3.08 0 0 1 3.083-3.079 3.08 3.08 0 0 1 3.083 3.079v58.493a3.08 3.08 0 0 1-3.083 3.079z"
                                        fill="#3940B2"
                                        data-color="1"
                                    ></path>
                                    <path
                                        d="M143.167 120.011H137a3.08 3.08 0 1 1 0-6.158h6.167c14.062 0 24.667-9.264 24.667-21.55V58.44H32.167v33.864c0 12.286 10.59 21.55 24.632 21.55H63c1.703 0 3.083 1.378 3.083 3.079s-1.381 3.079-3.083 3.079h-6.201C39.241 120.011 26 108.099 26 92.304V55.361c0-1.7 1.381-3.079 3.083-3.079h141.833a3.08 3.08 0 0 1 3.083 3.079v36.943c.001 15.795-13.254 27.707-30.832 27.707z"
                                        fill="#3940B2"
                                        data-color="1"
                                    ></path>
                                    <path
                                        d="M121.583 120.011H78.417c-1.703 0-3.083-1.378-3.083-3.079s1.381-3.079 3.083-3.079h43.167a3.08 3.08 0 1 1-.001 6.158z"
                                        fill="#3940B2"
                                        data-color="1"
                                    ></path>
                                    <path
                                        d="M121.583 49.204h-6.167v-3.079c0-3.396-2.767-6.157-6.167-6.157H87.667c-3.401 0-6.167 2.761-6.167 6.157v3.079h-6.167v-3.079c0-6.79 5.533-12.314 12.333-12.314h21.583c6.802 0 12.333 5.524 12.333 12.314v3.079z"
                                        fill="#3940B2"
                                        data-color="1"
                                    ></path>
                                    <path
                                        d="M78.417 129.246H63a3.08 3.08 0 0 1-3.083-3.079v-18.471c0-1.7 1.381-3.079 3.083-3.079h15.417a3.08 3.08 0 0 1 3.083 3.079v18.471a3.081 3.081 0 0 1-3.083 3.079zm-12.334-6.157h9.25v-12.314h-9.25v12.314z"
                                        fill="#3940B2"
                                        data-color="1"
                                    ></path>
                                    <path
                                        d="M137 129.246h-15.417a3.08 3.08 0 0 1-3.083-3.079v-18.471a3.08 3.08 0 0 1 3.083-3.079H137a3.08 3.08 0 0 1 3.083 3.079v18.471a3.08 3.08 0 0 1-3.083 3.079zm-12.333-6.157h9.25v-12.314h-9.25v12.314z"
                                        fill="#3940B2"
                                        data-color="1"
                                    ></path>
                                </g>
                            </svg>
                        </div>

                        <h5>Heritage and Innovation Workshops</h5>
                        <p>
                            NEAD offers a series of workshops focused on exploring and embracing African heritage while
                            fostering innovation. These workshops provide members with opportunities to learn about
                            historical and cultural aspects of African identity, as well as to develop new ideas and
                            projects that contribute to the intellectual and economic growth of the African community.
                        </p>
                        <a href="#govern">Read More</a>
                    </center>
                </div>
                {" "}
                <div className="col-md-4 padd">
                    <center>
                        <div className="aizuI7  ">
                            {" "}
                            <svg
                                preserveAspectRatio="xMidYMid meet"
                                data-bbox="34.5 28 130.999 144"
                                viewBox="34.5 28 130.999 144"
                                height="200"
                                width="200"
                                xmlns="http://www.w3.org/2000/svg"
                                data-type="color"
                                role="presentation"
                                aria-hidden="true"
                                aria-label=""
                            >
                                <g>
                                    <path
                                        d="M129.773 85.01h-5.955v-3.666c0-6.686-15.453-11.379-23.818-11.379-8.366 0-23.818 4.693-23.818 11.379v3.666h-5.955v-3.666c0-12.378 21.011-17.378 29.773-17.378 8.763 0 29.773 5 29.773 17.378v3.666z"
                                        fill="#3940B2"
                                        data-color="1"
                                    ></path>
                                    <path
                                        d="M93.489 172H80.293a2.98 2.98 0 0 1-2.836-2.087l-8.853-27.909H51.749c-9.51 0-17.249-7.796-17.249-17.378V88.597c0-6.94 5.604-12.586 12.492-12.586h.449c6.585 0 12.935 2.783 17.423 7.635l9.589 10.363h16.615c.834 0 1.63.353 2.194.973.564.618.845 1.449.772 2.285-.436 5.099-4.108 14.741-14.875 14.741H63.643a2.97 2.97 0 0 1-2.128-.901l-.22-.227v7.127h11.863c6.303 0 11.944 4.045 14.034 10.065.036.104.067.211.092.318l9.106 39.939a3.011 3.011 0 0 1-.573 2.541 2.965 2.965 0 0 1-2.328 1.13zm-11.021-5.999h7.282l-8.23-36.094c-1.295-3.536-4.636-5.901-8.362-5.901h-14.84c-1.644 0-2.977-1.343-2.977-3v-16.255l-8.382-8.627 4.257-4.198 13.68 14.081H79.16c4.947 0 7.176-3.315 8.17-5.999H73.158a2.966 2.966 0 0 1-2.178-.955L60.509 87.736a17.864 17.864 0 0 0-13.068-5.725h-.449c-3.605 0-6.537 2.954-6.537 6.587v36.028c0 6.275 5.066 11.379 11.294 11.379h19.03a2.98 2.98 0 0 1 2.836 2.087l8.853 27.909z"
                                        fill="#3940B2"
                                        data-color="1"
                                    ></path>
                                    <path
                                        d="M55.341 73.011c-8.07 0-14.886-6.868-14.886-14.998v-3c0-8.139 6.817-15.014 14.886-15.014s14.886 6.875 14.886 15.014v3c0 8.269-6.678 14.998-14.886 14.998zm0-27.013c-4.841 0-8.932 4.129-8.932 9.015v3c0 4.877 4.091 8.999 8.932 8.999s8.932-4.122 8.932-8.999v-3c0-4.886-4.091-9.015-8.932-9.015z"
                                        fill="#3940B2"
                                        data-color="1"
                                    ></path>
                                    <path
                                        d="M119.149 172h-13.194a2.966 2.966 0 0 1-2.329-1.131 3.022 3.022 0 0 1-.573-2.541l9.106-39.939c.023-.107.055-.214.09-.318 2.093-6.02 7.734-10.065 14.037-10.065h12.418v-7.685l-.797.804a2.963 2.963 0 0 1-2.108.882H120.84c-10.766 0-14.439-9.642-14.875-14.741a3.005 3.005 0 0 1 .77-2.285 2.968 2.968 0 0 1 2.195-.973h16.061l9.586-10.363c4.489-4.852 10.839-7.635 17.422-7.635h.451c7.074 0 13.049 5.764 13.049 12.586v36.028c0 9.419-8.153 17.378-17.805 17.378H130.84l-8.856 27.911a2.979 2.979 0 0 1-2.835 2.087zm-9.455-5.999h7.28l8.856-27.911a2.98 2.98 0 0 1 2.835-2.086h19.03c6.423 0 11.851-5.211 11.851-11.379V88.597c0-3.509-3.315-6.587-7.094-6.587h-.451a17.857 17.857 0 0 0-13.066 5.727l-10.47 11.316a2.968 2.968 0 0 1-2.178.955h-13.616c.991 2.682 3.222 5.999 8.17 5.999h13.723l13.962-14.1 4.216 4.236-8.083 8.164v16.699c0 1.657-1.332 3-2.977 3h-15.395c-3.727 0-7.068 2.365-8.365 5.901l-8.228 36.094z"
                                        fill="#3940B2"
                                        data-color="1"
                                    ></path>
                                    <path
                                        d="M144.659 73.011c-8.068 0-14.886-6.868-14.886-14.998v-3c0-8.139 6.818-15.014 14.886-15.014s14.886 6.875 14.886 15.014v3c0 8.13-6.818 14.998-14.886 14.998zm0-27.013c-4.841 0-8.932 4.129-8.932 9.015v3c0 4.877 4.091 8.999 8.932 8.999s8.932-4.122 8.932-8.999v-3c0-4.886-4.091-9.015-8.932-9.015z"
                                        fill="#3940B2"
                                        data-color="1"
                                    ></path>
                                    <path
                                        fill="#3940B2"
                                        d="M141.682 106.007v5.999H58.318v-5.999h83.364z"
                                        data-color="1"
                                    ></path>
                                    <path
                                        d="M100 61.012c-8.07 0-14.886-6.868-14.886-14.998v-3C85.114 34.875 91.93 28 100 28c8.068 0 14.886 6.875 14.886 15.014v3c0 8.131-6.818 14.998-14.886 14.998zm0-27.013c-4.841 0-8.932 4.129-8.932 9.015v3c0 4.877 4.091 8.999 8.932 8.999s8.932-4.122 8.932-8.999v-3c0-4.886-4.091-9.015-8.932-9.015z"
                                        fill="#3940B2"
                                        data-color="1"
                                    ></path>
                                </g>
                            </svg>
                        </div>

                        <h5>Networking and Mentorship Program</h5>
                        <p>
                            This program connects members with industry leaders, educators, and fellow innovators.
                            Through regular networking events, online forums, and a structured mentorship program,
                            members can share knowledge, gain insights, and collaborate on projects. This initiative
                            aims to build a strong, supportive community where members can grow both personally and
                            professionally.
                        </p>
                        <a href="#peer">Read More</a>
                    </center>
                </div>
                {" "}
                <div className="col-md-4 padd">
                    <center>
                        <div className="aizuI7  ">
                            {" "}
                            <svg
                                preserveAspectRatio="xMidYMid meet"
                                data-bbox="28 32.5 144 135"
                                viewBox="28 32.5 144 135"
                                height="200"
                                width="200"
                                xmlns="http://www.w3.org/2000/svg"
                                data-type="color"
                                role="presentation"
                                aria-hidden="true"
                                aria-label=""
                            >
                                <g>
                                    <path
                                        d="M169 143.5H88c-1.658 0-3-1.342-3-3v-39h6v36h75v-99H91v30h-6v-33c0-1.658 1.342-3 3-3h81c1.658 0 3 1.342 3 3v105c0 1.658-1.342 3-3 3z"
                                        fill="#3940B2"
                                        data-color="1"
                                    ></path>
                                    <path
                                        d="M43 137.5c-8.13 0-15-6.87-15-15v-27c0-13.934 9.085-21 27-21h60c1.658 0 3 1.342 3 3 0 8.514-7.392 18-18 18H79v39h-6v-42c0-1.658 1.342-3 3-3h24c6.026 0 10.166-4.591 11.52-9H55c-18.612 0-21 8.016-21 15v27c0 4.793 4.207 9 9 9v6z"
                                        fill="#3940B2"
                                        data-color="1"
                                    ></path>
                                    <path
                                        fill="#3940B2"
                                        d="M79 95.5v72h-6v-72h6z"
                                        data-color="1"
                                    ></path>
                                    <path
                                        fill="#3940B2"
                                        d="M64 128.5v39h-6v-39h6z"
                                        data-color="1"
                                    ></path>
                                    <path
                                        fill="#3940B2"
                                        d="M49 95.5v72h-6v-72h6z"
                                        data-color="1"
                                    ></path>
                                    <path
                                        d="M62.5 71.5c-9.407 0-16.5-6.448-16.5-15v-9c0-8.552 7.093-15 16.5-15S79 38.948 79 47.5v9c0 8.552-7.093 15-16.5 15zm0-33c-6.085 0-10.5 3.785-10.5 9v9c0 5.215 4.415 9 10.5 9s10.5-3.785 10.5-9v-9c0-5.215-4.415-9-10.5-9z"
                                        fill="#3940B2"
                                        data-color="1"
                                    ></path>
                                    <path
                                        fill="#3940B2"
                                        d="M133 137.5v27h-6v-27h6z"
                                        data-color="1"
                                    ></path>
                                    <path
                                        d="M149.093 163.835L130 144.742l-19.093 19.093-4.242-4.242 21.214-21.214a2.998 2.998 0 0 1 4.242 0l21.214 21.214-4.242 4.242z"
                                        fill="#3940B2"
                                        data-color="1"
                                    ></path>
                                </g>
                            </svg>
                        </div>

                        <h5>Educational Development Grants</h5>
                        <p>
                            NEAD provides grants sources to members who are working on projects aimed at improving
                            educational standards and access within African communities. These grants support
                            initiatives such as curriculum development, teacher training, and the creation of
                            educational materials. Members can apply for funding to bring their innovative ideas to life
                            and make a meaningful impact in education.
                        </p>
                        <a href="#family">Read More</a>
                    </center>
                </div>
            </div>
            <div className="family  mobile-padding" id="family">
                {" "}
                <div className="col-md-8 offset-md-2 flexy ">
                    <div
                        className="col-md-6 mt5 no-margin"
                        style={{paddingRight: "30px"}}
                    >
                        <center>
                            {" "}
                            <h4>Educational Development Grants</h4>
                            <h6>
                                Investing in your leaders makes good family business sense
                            </h6>
                            <p>NEAD's Educational Development Grants provide crucial support for members initiating projects aimed at improving educational standards and access within African communities. These grants empower educators and innovators to implement impactful initiatives such as curriculum enhancements, teacher training programs, and educational resource development.</p>
                            <p>By funding innovative projects, NEAD fosters tangible improvements in educational quality and equity, enabling members to make significant contributions to their communities. These grants not only provide financial assistance but also facilitate knowledge sharing and collaboration among members, amplifying the impact of their efforts and advancing NEAD’s mission of educational advancement and community empowerment.</p>
                            <h6>Who is it for?</h6>
                            <p>The Educational Development Grants are for NEAD members who are educators, educational institutions, innovators, and organizations committed to enhancing educational standards and access within African communities. These grants support individuals and groups with innovative ideas and projects that aim to make a meaningful impact in education, fostering growth and improvement across various educational sectors.</p>
                            <h6>Maximise your family business potential</h6>
                            <Link to={'/join-us'}><button>JOIN NEAD NOW</button></Link>
                        </center>
                    </div>
                    <div className="col-md-6 mt5 ">
                        <img src={Img1} width="100%" alt={""}/>
                        <img src={Img2} width="100%" className="mt1" alt={""}/>
                    </div>
                </div>
            </div>
            {" "}
            <div className="peer mtt no-margin" id="peer">
                {" "}
                <div className="col-md-8 offset-md-2 flexy ">
                    <div className="col-md-6 padding-response">
                        <center>
                            {" "}
                            <h4>Networking and Mentorship Program</h4>
                            <p>
                                NEAD's Networking and Mentorship Program connects members with industry leaders, educators, and peers, fostering a collaborative environment for professional growth. Through regular networking events and structured mentorship opportunities, participants engage in knowledge sharing and skill development.
                            </p>
                            <p>Members benefit from valuable insights and guidance from experienced mentors, enhancing their career trajectories and personal development. This program cultivates a supportive community where members can build lasting connections and leverage collective expertise to advance their goals and contribute to NEAD’s mission of educational advancement and cultural preservation.</p>
                            <h6>How to join:</h6>
                            <p>
                                To get started, click the button below or call us for
                                a discussion on +263773397495. After completing an
                                application form, you will be matched to an existing group or
                                become part of a newly forming group; the matching process
                                ensures there are no potential conflicts within your peer forum
                                group, for example family members or industry competitors.
                            </p>
                            <Link to={'/join-us'}><button>JOIN NEAD NOW</button></Link>
                        </center>
                    </div>
                    <div className="col-md-6 mt4 ">
                        <img src={Img3} width="100%" alt={""}/>
                    </div>
                </div>
            </div>
            {" "}
            <div className="family mtt" id="govern">
                {" "}
                <div className="col-md-8 offset-md-2 flexy ">
                    <div className="col-md-6 " style={{paddingRight: "30px"}}>
                        <center>
                            {" "}
                            <h4>Heritage and Innovation Workshops</h4>
                            <p>The Heritage and Innovation Workshops immerse members in the rich tapestry of African heritage while fostering a spirit of innovation and creativity. Covering topics such as African history, cultural practices, traditional arts, and contemporary technological advancements, these workshops provide a comprehensive learning experience.</p>
                            <p>Participants engage in interactive sessions led by experts, encouraging a deep understanding of their roots and how these can inform future innovations. Hands-on activities, group discussions, and collaborative projects help members explore the intersection of tradition and modernity.</p>
                            <p>Guest speakers, including thought leaders, cultural ambassadors, and successful innovators, share their experiences and insights, providing valuable guidance and inspiration. By participating in these workshops, members gain a deeper appreciation of their cultural identity and develop skills to drive meaningful change.</p>
                            <p>These workshops are a vital part of NEAD’s mission to reclaim Africa's intellectual future and contribute to a prosperous and respected global African presence. Through this program, members are empowered to apply ancestral wisdom to address current challenges and opportunities.</p>
                            <Link to={'/join-us'}>
                                <button>JOIN NEAD NOW</button>
                            </Link>
                        </center>
                    </div>
                    <div className="col-md-6 mt4">
                        <img src={Img4} width="100%" alt={""}/>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Membership;
